<template>
  <fieldset class="v-date-input__container" aria-label="Dato">
    <div class="row">
      <div class="col-4">
        <v-input
          :required="required"
          date-input="date"
          type="tel"
          name="day"
          :placeholder="placeholders.day"
          :value="dateObj.day"
          error="Indtast gyldig dato"
          description="DD"
          pattern="^(0[1-9]|[12][0-9]|3[01])$"
          :min="1"
          :max="31"
          @input="dateObj.day = $event.target.value"
          :invalid="isInvalid"
        />
      </div>
      <div class="col-4">
        <v-input
          :required="required"
          :value="dateObj.month"
          date-input="month"
          type="tel"
          name="month"
          :placeholder="placeholders.month"
          error="Indtast gyldigt måned"
          description="MM"
          pattern="^(0[1-9]|1[0-2])$"
          :min="1"
          :max="12"
          @input="dateObj.month = $event.target.value"
          :invalid="isInvalid"
        />
      </div>
      <div class="col-4">
        <v-input
          :required="required"
          :value="dateObj.year"
          type="tel"
          name="year"
          description="ÅÅÅÅ"
          :placeholder="placeholders.year"
          date-input="year"
          error="Indtast gyldigt år"
          @input="dateObj.year = $event.target.value"
          pattern="^(19|20)\d{2}$"
          :invalid="isInvalid"
        />
      </div>
    </div>
  </fieldset>
</template>
<script>
import moment from "moment";

export default {
  name: "v-date-input",
  props: {
    date: {
      type: [String, Date],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    placeholders: {
      type: Object,
      default: () => ({
        day: "Dato",
        month: "Måned",
        year: "År"
      })
    }
  },
  data() {
    return {
      dateObj: {
        day: null,
        month: null,
        year: null
      },
      isInvalid: false
    };
  },
  computed: {},
  watch: {
    reset(val) {
      if (val) {
        this.dateObj.day = null;
        this.dateObj.month = null;
        this.dateObj.year = null;
      }
    },
    dateObj: {
      handler(val) {
        if (val.day && val.month && val.year && val.year.length === 4) {
          this.onInput();
        }
      },
      deep: true
    },
    date: {
      immediate: true,
      handler(val) {
        // if there is date in iso format, autofill into input fields
        if (val) {
          const date = moment(val);
          if (date) {
            this.dateObj.day = date.format("DD");
            this.dateObj.month = date.format("MM");
            this.dateObj.year = date.format("YYYY");
          }
        }
      }
    }
  },
  methods: {
    onInput() {
      this.isInvalid = false;
      if (this.dateObj.day && this.dateObj.month && this.dateObj.year) {
        const completeDate = `${this.dateObj.month}/${this.dateObj.day}/${this.dateObj.year}`;
        const date = moment.utc(completeDate, "MM/DD/YYYY").toISOString();
        if (moment(date).isValid()) {
          this.isInvalid = false;
          // Clear custom validity on all input fields
          this.$el.querySelectorAll("input").forEach(input => {
            input.setCustomValidity("");
          });
          this.$emit("date", date);
        } else {
          this.isInvalid = true;
          // Set custom validity on at least one input field to prevent form submission
          this.$el
            .querySelector('input[name="day"]')
            .setCustomValidity("Invalid date");
          // You can also set a more specific message
        }
      }
    }
  }
};
</script>
<style scoped>
.v-date-input__container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}
</style>
